// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amountInputStyle_buttonContainer__CYmK3 {
  white-space: nowrap;
}

.amountInputStyle_decreaseButton__YQ7wK,
.amountInputStyle_increaseButton__ARXd7 {
  min-width: unset;
}

.amountInputStyle_quantityText__yqIDk {
  top: 0.1em;
  margin: 0 0.2em;
  border-radius: 4px;
  width: 3em;
  height: 2.1em;
  border: none;
  text-align: center;
  font-weight: bold;
  font-size: 1em;
  background: inherit;
}

.amountInputStyle_quantityText__yqIDk:hover,
.amountInputStyle_quantityText__yqIDk:focus {
  background: #eee;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order_management/orderedit_components/Styles/amountInputStyle.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB","sourcesContent":[".buttonContainer {\n  white-space: nowrap;\n}\n\n.decreaseButton,\n.increaseButton {\n  min-width: unset;\n}\n\n.quantityText {\n  top: 0.1em;\n  margin: 0 0.2em;\n  border-radius: 4px;\n  width: 3em;\n  height: 2.1em;\n  border: none;\n  text-align: center;\n  font-weight: bold;\n  font-size: 1em;\n  background: inherit;\n}\n\n.quantityText:hover,\n.quantityText:focus {\n  background: #eee;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonContainer": `amountInputStyle_buttonContainer__CYmK3`,
	"decreaseButton": `amountInputStyle_decreaseButton__YQ7wK`,
	"increaseButton": `amountInputStyle_increaseButton__ARXd7`,
	"quantityText": `amountInputStyle_quantityText__yqIDk`
};
export default ___CSS_LOADER_EXPORT___;
